export enum AccountTypeEnum {
  person = 'person',
  company = 'company',
}

export type AccountType = 'person' | 'company';
